export const PRODUCTS_BASE_ROUTE = '/products';

export const CATALOG_ROUTES = {
  productList: PRODUCTS_BASE_ROUTE,
  newProduct: '/products/new',
  newProductFromImages: '/products/new-from-images',
  organizeFeaturedProducts: '/products/featured',
  organizeProducts: '/products/organize',
  importAndExportProducts: '/products/import',
  importProducts: '/products/import/onboarding',
  editProduct: '/products/:id',
  inventoryList: '/inventory',
  editInventory: '/inventory/:productId/:variantId',
  categoriesList: '/categories',
  editCategory: '/categories/:id',
  metaplansList: '/subscriptions',
  newMetaplan: '/subscriptions/new',
  priceTables: '/price-tables',
  transfers: '/transfers-products',
  newTransfer: '/transfers-products/new',
  viewTransferDetails: '/transfers-products/:id',
};
